import axios from '../server/axios'
import { ref } from 'vue'
const res = await fetch('/config.json')
const config = ref({})
config.value = await res.json()
const w_id = config.value.w_id || '1'
export const homeData = () => axios.get(`/v1/api/getconfig${w_id ? '?w_id=' + w_id : ''}`)

export const getVideo = (params) => axios.get(`/v1/api/getVideo${params ? '?' + params : ''}`)
